import React, { useState, useEffect, useCallback, useRef } from "react";
import { Layout, Button, Popconfirm, notification } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { Row, Form, Input, Col, Select, Collapse } from "antd";

import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import QuestionnairesApi from "../../common/Apis/QuestionnairesApi";
import { MinusCircleTwoTone, PlusCircleTwoTone } from "@ant-design/icons";
import DepartmentsApi from "../../common/Apis/DepartmentsApi";
import EmptyBox from "../../common/CommonUI/EmptyBox";
import Pagination from "../../common/Pagination/Pagination"; 
import "../../common/Pagination/Pagination.css"; 

const Departments = () => {
  let navigate = useNavigate();
  const { Content } = Layout;
  const { Panel } = Collapse;



  const [PaginatePage, setPaginatePage] = useState(0);
  const [PaginatetotalPages, settotalPages] = useState(null);
  const [PaginateLimit, setPaginateLimit] = useState(10);
  const [totalElements, setTotalElements] = useState(0);

  const [formPaginate] = Form.useForm();
  formPaginate.setFieldsValue({
    paginate: PaginateLimit,
  });
  const handlesetPaginateLimit = (value) => {
    setPaginateLimit(value);
    setCurrentPage(1);
    formPaginate.setFieldsValue({
      paginate: value,
    });
    DepartmentsApi.ListDepartments(0, value)
      .then((response) => {
        settotalPages(response.totalPages);
        setDepartments(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => {
        console.log(err);
      });
  };
  const [currentPage, setCurrentPage] = useState(1);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    let pageNew = page - 1
    DepartmentsApi.ListDepartments(pageNew, PaginateLimit)
      .then((response) => {
        setPaginatePage(pageNew)
        settotalPages(response.totalPages);
        setDepartments(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => {
        console.log(err);
      });
  };


  const [Departments, setDepartments] = React.useState([]);
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const getDepartments = useCallback(() => {
    DepartmentsApi.ListDepartments(PaginatePage, PaginateLimit)
      .then((response) => {
        settotalPages(response.totalPages);
        setDepartments(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const [isLoading, setIsLoading] = useState(false);
  const PageLoading = useCallback(() => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
  }, []);

  useEffect(() => {
    PageLoading();
    getDepartments();
  }, [getDepartments, PageLoading]);

  const handleDeleteDepartments = (DepartmentID) => {
    DepartmentsApi.DeleteDepartments(DepartmentID)
      .then((response) => {
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Deleted</span>,
          description: "Delete Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        PageLoading();
        getDepartments();
      })
      .catch((err) => {
        if (err.apiError.status) {
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };

  const handleRemovefilterDepartment = (FilterDepartmentIndex) => {
    const newfilterDepartment = [...filterDepartment];
    newfilterDepartment.splice(FilterDepartmentIndex, 1);
    setFilterDepartments(newfilterDepartment);
    if (FilterDepartmentIndex == 0) {
      getDepartments();
    }
  };
  const handleClear = () => {
    getDepartments();
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
    setFilterDepartments([
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
  };
  const formRef = useRef(null);

  const [filterDepartment, setFilterDepartments] = useState([
    {
      title: "",
      answerType: "",
      name: "",
    },
  ]);

  const handleAddfilterDepartments = () => {
    setFilterDepartments([
      ...filterDepartment,
      {
        title: "",
        answerType: "",
        name: "",
      },
    ]);
  };

  const handleSubmit = (data) => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 800);
    let singleLineString = filterDepartment
      .map((obj) => {
        if (obj.answerType === "%") {
          return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
        } else if (obj.answerType === "=") {
          return `${obj.title}${obj.answerType}${obj.name}`;
        } else {
          return `${obj.title}=${obj.name}`;
        }
      })
      .join("&");

    let filderData = window.btoa(
      "componentCode=INSTITUTION&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString
    );
    QuestionnairesApi.FilterQuestionsetNext(filderData, 0, PaginateLimit)
      .then((response) => {
        setCurrentPage(1);
        settotalPages(response.totalPages);
        setDepartments(response.payloadDto);
        setTotalElements(response.totalElements);

      })
      .catch((err) => { });
  };
  const handleChangeTitle = (filterDepartmentIndex, value) => {
    const newfilterDepartment = [...filterDepartment];
    newfilterDepartment[filterDepartmentIndex].title = value;
    setFilterDepartments(newfilterDepartment);
  };
  const handleChangeAnswertype = (filterDepartmentIndex, value) => {
    const newfilterDepartment = [...filterDepartment];
    newfilterDepartment[filterDepartmentIndex].answerType = value;
    setFilterDepartments(newfilterDepartment);
  };

  const handleChangename = (filterDepartmentIndex, value) => {
    const newfilterDepartment = [...filterDepartment];
    newfilterDepartment[filterDepartmentIndex].name = value;
    setFilterDepartments(newfilterDepartment);
  };

  const paginatedData = Departments;

  const renderTableRows = () => {
    if (paginatedData.length > 0) {
      return paginatedData.map((item) => (
        <tr key={item.id} className="text-center">
          <td style={{ width: "22%" }} className="pt-3">
            {item?.code}
          </td>
          <td style={{ width: "32%" }} className="pt-3">
            {item?.institutionName}
          </td>
          <td style={{ width: "20%" }} className="pt-3">
            {item?.institutionType}
          </td>
          <td style={{ width: "13%" }}>
            <div className="d-flex ">
              <Link
                to={`/masters/departments/edit-department?id=${item?.id}`}
                className={decodedToken?.permissions?.some(
                  (permission) => permission?.authority === 'EDIT_INSTITUTION'
                ) ? 'btn btn-primary btn-save table-action icon-center w-100' : 'd-none'}
              >
                <EditOutlined />
                Edit
              </Link>
              {/* <Popconfirm
                title="Are you sure ?"
                description="Do you really want to delete this Departments ?"
                okText="Yes"
                onConfirm={() => handleDeleteDepartments(item.id)}
                placement="topRight"
                className="w-100"
                cancelText="No"
              >
                <Link
                  to={``}
                  className={decodedToken?.permissions?.some(
                    (permission) => permission?.authority === 'DELETE_INSTITUTION'
                  ) ? 'btn btn-primary btn-back table-action icon-center mx-1' : 'd-none'}
                >
                  <DeleteOutlined />
                  Delete
                </Link>
              </Popconfirm> */}
            </div>
          </td>
        </tr>
      ));
    } else {
      return (
        <tr className="text-center EmptyTable">
          <td colSpan={4} className="text-center ">
            <EmptyBox />
            <br />
            {/* <Button
              className={decodedToken?.permissions?.some(
                (permission) => permission?.authority === 'ADD_INSTITUTION'
              ) ? 'btn btn-primary btn-save m-0 my-4' : 'd-none'}
              href={"/masters/departments/add-department"}
            >
              Add new
            </Button> */}
            <Button
              type="primary"
              onClick={() => navigate("/masters/departments/add-department")}
              style={{
                display: decodedToken?.permissions?.some(
                  permission => permission?.authority === 'ADD_INSTITUTION'
                ) ? '' : 'none',
                height: 'auto',
                lineHeight: 'normal',
                alignItems: 'center',
                padding: '5px 24px',
              }}
            >
              Add new department
            </Button>
          </td>
        </tr>
      );
    }
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />
        {isLoading && (
          <div className="spinner-overlay" id="spinnerOverlay">
            <div className="spinner"></div>
          </div>
        )}
        <div
          style={{
            padding: "20px",
            paddingBottom: "5px",
          }}
        >
          <Form
            ref={formRef}
            name="nest-messages"
            layout="vertical"
            className="FormClass FilterForm"
            onFinish={handleSubmit}
          >
            <>
              <Collapse>
                <Panel
                  header={
                    <h5 className="mb-0">
                      <b>Filter</b>
                    </h5>
                  }
                  key="1"
                >
                  {filterDepartment.map((input, filterDepartmentIndex) => (
                    <div key={filterDepartmentIndex}>
                      <Row gutter={12} className="pt-2">
                        <Col span={5}>
                          <Form.Item
                            name={`title${filterDepartmentIndex}`}
                            className="text-lable"
                            rules={[
                              {
                                required: true,
                                message: "Please Select",
                              },
                            ]}
                          >
                            <Select
                              className="control-Select"
                              placeholder="Filter By"
                              value={input.title}
                              onChange={(value) =>
                                handleChangeTitle(filterDepartmentIndex, value)
                              }
                              options={[
                                { value: "code", label: "Code" },
                                {
                                  value: "institutionName",
                                  label: "Name",
                                },
                              ]}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={4}>
                          <Form.Item
                            name={`type${filterDepartmentIndex}`}
                            className="text-lable"
                            rules={[
                              {
                                required: true,
                                message: "Please Select type.",
                              },
                            ]}
                          >
                            <Select
                              className="control-Select mb-1"
                              placeholder="Condition"
                              onChange={(value) =>
                                handleChangeAnswertype(
                                  filterDepartmentIndex,
                                  value
                                )
                              }
                              options={[
                                { value: "%", label: "Matches with" },
                                {
                                  value: "=",
                                  label: "Equals to",
                                },
                              ]}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={5}>
                          <Form.Item
                            name={`name${filterDepartmentIndex}`}
                            className="text-lable"
                            rules={[
                              {
                                required: true,
                                message: "Please enter Text.",
                              },
                            ]}
                          >
                            <Input
                              type="text"
                              onChange={(e) =>
                                handleChangename(
                                  filterDepartmentIndex,
                                  e.target.value
                                )
                              }
                              placeholder="Text"
                              className="control-input"
                            />
                          </Form.Item>
                        </Col>

                        <Col span={8}>
                          <Form.Item className="text-lable">
                            {filterDepartmentIndex == 0 ? (
                              <>
                                <Row gutter={23} className="mb-3">
                                  <Col span={2} className="mx-0">
                                    <Form.Item className="text-lable">
                                      <PlusCircleTwoTone
                                        onClick={handleAddfilterDepartments}
                                      />
                                    </Form.Item>
                                  </Col>

                                  <Col span={10}>
                                    <Button
                                      type="primary"
                                      htmlType="submit"
                                      className="btn btn-primary btn-save table-action icon-center "
                                    >
                                      Filter
                                    </Button>
                                  </Col>
                                  <Col span={10}>
                                    <Button
                                      type="reset"
                                      htmlType="reset"
                                      onClick={() => handleClear()}
                                      style={{ color: "#0b5ed7" }}
                                      className="btn btn-primary btn-back table-action icon-center"
                                    >
                                      Clear
                                    </Button>
                                  </Col>
                                </Row>
                              </>
                            ) : (
                              <>
                                {" "}
                                <MinusCircleTwoTone
                                  onClick={() =>
                                    handleRemovefilterDepartment(
                                      filterDepartmentIndex
                                    )
                                  }
                                />
                              </>
                            )}
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>
                  ))}
                </Panel>
              </Collapse>
            </>
          </Form>
        </div>

        <Content
          className="form-content nav-content"
          style={{
            margin: "14px 16px 0",
            padding: "30px",
            background: "white",
          }}
        >
          <div>

            <div className="d-flex justify-content-between align-items-center">
              <div>
                {paginatedData?.length > 0 && (
                  <div className="col-xl-12 col-lg-7 col-md-12 px-0 ">
                    <Button
                      type="primary"
                      onClick={() => navigate("/masters/departments/add-department")}
                      style={{
                        display: decodedToken?.permissions?.some(
                          permission => permission?.authority === 'ADD_INSTITUTION'
                        ) ? '' : 'none',
                        height: 'auto',
                        lineHeight: 'normal',
                        alignItems: 'center',
                        padding: '5px 24px',
                      }}
                    >
                      Add new department
                    </Button>
                  </div>
                )}
              </div>
              <div>

                <Form
                  form={formPaginate}
                >
                  <Form.Item
                    name="paginate"
                    className="text-lable"
                    style={{ width: '100px' }}
                  >
                    <Select
                      className="control-Select"
                      onChange={(value) => {
                        handlesetPaginateLimit(value)
                      }}
                      options={[
                        { value: 10, label: "10" },
                        { value: 20, label: "20" },
                        { value: 30, label: "30" },
                        { value: 40, label: "40" },
                        { value: 50, label: "50" },
                      ]}
                    />
                  </Form.Item>
                </Form>

              </div>
            </div>
            <table className="table users-table">
              <thead>
                <tr>
                  <th>Code</th>
                  <th>Name</th>
                  <th>Type</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>{renderTableRows()}</tbody>
            </table>
            {paginatedData?.length > 0 && (
            <Pagination
              currentPage={currentPage}
              totalPages={PaginatetotalPages}
              onPageChange={handlePageChange}
              maxVisiblePages={5}
              showPageInfo={true}
              totalItems={totalElements}
              pageSize={PaginateLimit}
            />
          )}
          </div>
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};

export default Departments;
